import React, { ChangeEvent, Component } from "react";
import * as _ from "lodash-es";
import IGetTotalLoginsReportDTO from "../../../../models/DTO/IGetTotalLoginsReportDTO";
import IOnGetTotalLoginsReportDTO from "../../../../models/DTO/IOnGetTotalLoginsReportDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IOwTableCols from "../../../../models/IOwTableCols";
import ISupplierModel from "../../../../models/ISupplierModel";
import ITotalLoginsUserRow from "../../../../models/ITotalLoginsUserRow";
import IUserUI from "../../../../models/IUserUI";
import ReportPeriodType from "../../../../models/ReportPeriodTypeEnum";
import SortOrderEnum from "../../../../models/SortOrderEnum";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTable from "../../../shared/OwTable/OwTable";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import "./TotalLoginsReport.scss";
import IProcessed_Report from "../../../../models/IProcessed_Report";

type Props = {
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    processedReport: IProcessed_Report;
};

type State = {
    supplierUsers: ITotalLoginsUserRow[];
    vendorsUsers: {
        vendor_name: string;
        email: string;
        name: string;
        total_logins: number;
    }[];
    dataFetching: boolean;
    initialData: boolean;
    supplierUserColumns: IOwTableCols[];
    vendorUserColumns: IOwTableCols[];
    sortCol: string;
    sortOrder: SortOrderEnum;
    show_supplier_users: boolean;
    show_vendor_users: boolean;
};

export default class TotalLoginsReport extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            show_supplier_users: true,
            show_vendor_users: true,
            supplierUsers: [],
            vendorsUsers: [],
            dataFetching: false,
            initialData: false,
            supplierUserColumns: [
                {
                    title: "name",
                    valueProp: "name",
                },
                {
                    title: "email",
                    valueProp: "email",
                },
                {
                    title: "total_logins",
                    valueProp: "total_logins",
                    className: "text-end",
                },
            ],
            vendorUserColumns: [
                {
                    title: "vendor",
                    valueProp: "vendor_name",
                    isVendorOverride: true,
                    isSortable: true,
                    sortOrderFn: () => {
                        return this.state.sortOrder;
                    },
                    sortFn: (sortCol: string, sortOrder: SortOrderEnum) => {
                        this.sortCol("vendor_name", sortOrder);
                    },
                },
                {
                    title: "name",
                    valueProp: "name",
                },
                {
                    title: "email",
                    valueProp: "email",
                },
                {
                    title: "total_logins",
                    valueProp: "total_logins",
                    className: "text-end",
                    isSortable: true,
                    sortOrderFn: () => {
                        return this.state.sortOrder;
                    },
                    sortFn: this.sortCol,
                },
            ],
            sortCol: "vendor_name",
            sortOrder: SortOrderEnum.ASC,
        };
    }

    componentDidMount(): void {
        this.onGetTotalLoginsReport(this.props.processedReport.report_data);
    }

    componentWillUnmount(): void {}

    sortCol = (sortCol: string, sortOrder: SortOrderEnum) => {
        const vendorsUsers = _.orderBy(this.state.vendorsUsers, sortCol, sortOrder);

        this.setState({
            sortCol,
            sortOrder,
            vendorsUsers,
        });
    };

    getTotalLoginsReport = () => {
        // let payload: IGetTotalLoginsReportDTO = {
        //     userGuid: this.props.userModel.guid,
        //     userToken: this.props.userModel.token,
        //     supplierGuid: this.props.supplierModel.guid,
        // };
        //
        // this.props.socket.emit(EndpointsEnum.ReportGetTotalLogins, payload);
        //
        // this.setState({
        //     dataFetching: true,
        // });
    };

    onGetTotalLoginsReport = (data: IOnGetTotalLoginsReportDTO) => {
        this.setState({
            supplierUsers: data.supplierUsers,
            vendorsUsers: data.vendorsUsers,
            dataFetching: false,
            initialData: false,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state);
    };

    render() {
        return (
            <div className={"TotalLoginsReport"}>
                <div>
                    {
                        <div className={"d-print-none"}>
                            <OwCheckbox
                                fn={this.handleChange}
                                name={"show_supplier_users"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={this.state.show_supplier_users}
                                label={"supplier_users"}
                                labelClassName={"me-3"}
                            />
                            <OwCheckbox
                                fn={this.handleChange}
                                name={"show_vendor_users"}
                                truthyVal={true}
                                falsyVal={false}
                                checked={this.state.show_vendor_users}
                                label={"vendor_users"}
                                supplierModel={this.props.supplierModel}
                                isSupplierVendorOverride={true}
                            />
                        </div>
                    }

                    {this.state.show_supplier_users ? (
                        <div>
                            <div>
                                <OwTitle title={"supplier_users"} tag={"h3"} />
                            </div>
                            <OwTable
                                columns={this.state.supplierUserColumns}
                                dataSet={this.state.supplierUsers}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                dataFetch={this.state.dataFetching}
                                initialData={this.state.initialData}
                            />
                        </div>
                    ) : null}

                    {this.state.show_vendor_users ? (
                        <div>
                            <div>
                                <OwTitle
                                    title={"vendor_users"}
                                    tag={"h3"}
                                    isSupplierVendorOverride={true}
                                    supplierModel={this.props.supplierModel}
                                />
                            </div>
                            <OwTable
                                columns={this.state.vendorUserColumns}
                                dataSet={this.state.vendorsUsers}
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                dataFetch={this.state.dataFetching}
                                initialData={this.state.initialData}
                                currentSortCol={this.state.sortCol}
                                tableConfig={{ tableHasSort: true }}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}
